// extracted by mini-css-extract-plugin
export var card = "_mf-1";
export var summary = "_mf-0";